import i18n from 'i18n'
import { ParticipantTagInput } from 'types/Participants'
import { SelectAll } from 'types/SelectAll'

const hasNewTagAdded = (tags: ParticipantTagInput[]) =>
  tags.some((tag) => tag.inputValue)

export const getAlertTitle = (tags: ParticipantTagInput[]) => {
  /**
   * Alert message use cases:
   * 1. Single tag has been added.
   * 2. Multiple tags have been added.
   * 3. Single new tag has been added.
   * 4. Multiple new/existing tags have been added.
   */

  const hasNewTag = hasNewTagAdded(tags)
  const doesNotHaveNewTag = !hasNewTag

  const singleTag = tags.length === 1
  const multipleTags = tags.length > 1
  const hasOnlyNewTag = singleTag && hasNewTag
  const hasOnlyExistingTag = singleTag && doesNotHaveNewTag
  const hasOnlyExistingTags = multipleTags && doesNotHaveNewTag
  const hasExistingAndNewTags = multipleTags && hasNewTag

  let alertTitle = ''

  switch (true) {
    case hasOnlyNewTag:
      alertTitle = i18n.t('participant.bulkTag.alertSuccess.hasOnlyNewTag')
      break

    case hasOnlyExistingTag:
      alertTitle = i18n.t('participant.bulkTag.alertSuccess.hasOnlyExistingTag')
      break

    case hasOnlyExistingTags:
      alertTitle = i18n.t(
        'participant.bulkTag.alertSuccess.hasOnlyExistingTags',
      )
      break

    case hasExistingAndNewTags:
      alertTitle = i18n.t(
        'participant.bulkTag.alertSuccess.hasExistingAndNewTags',
      )
      break

    default:
      alertTitle = i18n.t(
        'participant.bulkTag.alertSuccess.hasOnlyExistingTags',
      )
  }

  return alertTitle
}

export const getBulkTagRequestPayload = ({
  tags,
  selectedParticipantIDs,
  selectAll,
  segmentId,
}: {
  tags: ParticipantTagInput[]
  selectedParticipantIDs: string[]
  selectAll: SelectAll
  segmentId: string
}) => {
  const formattedTags = tags.map((tag) => tag.name)
  let payload
  const bulkTagObj = {
    user_ids: [],
    selected_all: 'true',
    tags: formattedTags,
  }
  // When select all participants across grid with filtering
  if (selectAll.all && segmentId != '0' && segmentId != '') {
    payload = {
      data: {
        attributes: {
          bulk_tag: {
            ...bulkTagObj,
            segment_id: segmentId,
          },
        },
      },
    }
    return payload
  }
  // When select all participants across grid without filtering
  if (selectAll.all) {
    payload = {
      data: {
        attributes: {
          bulk_tag: bulkTagObj,
        },
      },
    }
    return payload
  }
  // When few participants are selected
  payload = {
    data: {
      attributes: {
        bulk_tag: {
          ...bulkTagObj,
          selected_all: 'false',
          user_ids: selectedParticipantIDs,
        },
      },
    },
  }
  return payload
}

export const enableOrDisableBulkTag = (
  selectAll: SelectAll,
  selectedParticipantIDs: string[],
) =>
  !(selectAll.all || selectAll.allVisible || selectedParticipantIDs.length > 0)
